import $ from 'jquery'
import 'jquery-migrate';
window.$ = window.jQuery = $;

$.migrateMute = true;
$.migrateTrace = false;

import './bootstrap';

// Animate.css
import 'animate.css';

// Animate On Scroll

import aos from 'aos';
window.AOS = aos

// Bootbox

import bootbox from 'bootbox';
window.bootbox = bootbox;

// Bootstrap Table
import('bootstrap-table');

// Bootstrap Table - Extensions - Table Mobile
import('bootstrap-table/src/extensions/mobile/bootstrap-table-mobile.js');

// Chosen
import('chosen-js');

// Flatpickr

import { Dutch } from 'flatpickr/dist/l10n/nl';
import { German } from 'flatpickr/dist/l10n/de';
import { French } from 'flatpickr/dist/l10n/fr';
import { Spanish } from 'flatpickr/dist/l10n/es';
import { Italian } from 'flatpickr/dist/l10n/it';

const languageMap = {
    nl: Dutch,
    de: German,
    fr: French,
    es: Spanish,
    it: Italian,
};

window.flatpickr = require('flatpickr');

window.flatpickrLanguageSwitch = (locale = 'en') => {
    return languageMap[locale] || undefined;
};

// Google Api libraries (note that MarkerClusterer is a separate package)
window.googleApi = require('./app/googleApis').setupGoogleApi(process.env.MIX_GOOGLE_MAPS_API_KEY);

// GLightbox

import glightbox from 'glightbox';
window.GLightbox = glightbox

// jQuery UI - autocomplete
import 'jquery-ui/ui/widgets/autocomplete.js';

// NProgress

import nprogress from 'nprogress';
window.NProgress = nprogress;

// Password Strength Meter
window.pwStrengthTranslator = require('./app/password.js').setupPwStrengthTranslator(window.locale);

// PureCounter
import PureCounter from "@srexi/purecounterjs";
const pure = new PureCounter();

// Signature Pad
import SignaturePad from 'signature_pad';
window.SignaturePad = SignaturePad;

// SweetAlert2

import sweetalert2 from 'sweetalert2';
window.Swal = sweetalert2;

// Typed

import typed from 'typed.js';
window.Typed = typed;

// App

require ('./app/actions.js');
require ('./app/backToTop.js');
require ('./app/can.js');
require ('./app/chosen.js');
require ('./app/colorCellStyle.js');
require ('./app/cookieBanner.js');
require ('./app/datepicker.js');
require ('./app/i18n.js');
require ('./app/logout.js');
require ('./app/nbrogress.js');
require ('./app/ready.js');
require ('./app/sticky.js');
require ('./app/tables.js');
require ('./app/tabs.js');
require ('./app/validation.js');
require ('./app/whatsApp.js');

// Formatters

require ('./app/formatters/amountExclVat');
require ('./app/formatters/assignment/reaction/action.js');
require ('./app/formatters/assignment/reaction/curriculumVitae.js');
require ('./app/formatters/assignment/resubmit.js');
require ('./app/formatters/boolean.js');
require ('./app/formatters/button/order.js');
require ('./app/formatters/client/verified.js');
require ('./app/formatters/contract/detail.js');
require ('./app/formatters/contract/document_model_agreement.js');
require ('./app/formatters/contract/document_non_disclosure_agreement.js');
require ('./app/formatters/curriculum_vitae/reference/detail.js');
require ('./app/formatters/curriculum_vitae/work_experience/detail.js');
require ('./app/formatters/delete.js');
require ('./app/formatters/edit.js');
require ('./app/formatters/freelancer/verified.js');
require ('./app/formatters/pricePerCredit.js');
require ('./app/formatters/sales/invoice/creditedBy');
require ('./app/formatters/sales/invoice/creditedFor.js');
require ('./app/formatters/sales/invoice/detail.js');
require ('./app/formatters/sales/invoice/download.js');
require ('./app/formatters/reaction/cancel.js');
require ('./app/formatters/reaction/detail.js');
require ('./app/formatters/relation/verified.js');
require ('./app/formatters/show.js');
require ('./app/formatters/url.js');